import {
  Address,
  Address as MailingAddress,
  Address as RemitToAddress,
  Address as StreetAddress
} from './address';
import { ApConfig } from './ap-config';
import { ApVendor } from './ap-vendor';
import { ApVendorMeta } from './ap-vendor-meta';
import { BusinessVerificationApiError } from './business-verification-api-error';
import { BusinessVerificationApiErrorCode } from './business-verification-api-error-code';
import {
  CanadianWorkersCompensation,
  CanadianWorkersCompensation as WCB,
  CanadianWorkersCompensation as WSIB
} from './canadian-workers-compensation';
import { ClientRegisteredVendor } from './client-registered-vendor';
import { ClientRegisteredVendorFee } from './client-registered-vendor-fee';
import { ClientRegisteredVendorInvoice } from './client-registered-vendor-invoice';
import { ClientRegisteredVendorInvoiceFee } from './client-registered-vendor-invoice-fee';
import { Company } from './company';
import { CompanyComplianceType } from './company-compliance-type';
import { CompanyFee } from './company-fee';
import { CompanyOffice } from './company-office';
import { CompanyOperationState } from './company-operation-state';
import { CompanyPackagePricing } from './company-package-pricing';
import { CompanyRanking } from './company-ranking';
import { CompanyServiceRanking } from './company-service-ranking';
import { CompanyVendor } from './company-vendor';
import { CompanyVendorFile } from './company-vendor-file';
import { CompanyVendorOffice } from './company-vendor-office';
import {
  CompanyVendorPayment,
  CompanyVendorPayment as RecentPaidCompanyVendorPayment,
  CompanyVendorPayment as RecentPendingOrPaidCompanyVendorPayment
} from './company-vendor-payment';
import { CompanyVendorStatusChange } from './company-vendor-status-change';
import { ComplianceSetting } from './compliance-setting';
import {
  Contact as BidContact,
  Contact as BillingContact,
  Contact as ComplianceContact,
  Contact,
  Contact as PrimaryContact,
  Contact as SiteContact,
  Contact as VendorContact
} from './contact';
import { Contract } from './contract';
import {
  ContractSite as AssignedContractSite,
  ContractSite
} from './contract-site';
import { Email } from './email';
import { ESignProvider } from './esign-provider';
import { ESignTemplate } from './esign-template';
import { ExemptVendor } from './exempt-vendor';
import { ExemptVendorType } from './exempt-vendor-type';
import { File } from './file';
import { FileContent } from './file-content';
import { FrequencyPeriod } from './frequency-period';
import { InsuranceCertificate } from './insurance-certificate';
import { InsuranceDocument } from './insurance-document';
import { InsurancePolicy } from './insurance-policy';
import { InsurancePolicySite } from './insurance-policy-site';
import { Invoice } from './invoice';
import { IRSReport } from './irs-report';
import { LexNexReport } from './lex-nex-report';
import { License, License as Licenses } from './license';
import { Note } from './note';
import { Owner } from './owner';
import { OwnerFinding } from './owner-finding';
import {
  PaymentCustomer,
  PaymentCustomer as StripePaymentCustomer
} from './payment-customer';
import { PaymentIdentifierSetup } from './payment-identifier-setup';
import { PaymentProvider } from './payment-provider';
import { PrimaryTrade } from './primary-trade';
import {
  PrimaryTradeLicenseRequirement,
  PrimaryTradeLicenseRequirement as PrimaryTradeLicenseRequirements
} from './primary-trade-license-requirement';
import { Proposal } from './proposal';
import { ProposalFile } from './proposal-file';
import { ProposalRequest } from './proposal-request';
import { ProposalRequestFile } from './proposal-request-file';
import { ProposalRequestVendor } from './proposal-request-vendor';
import { RequestJob } from './request-job';
import { SignedDocument } from './signed-document';
import { SignedDocumentFile } from './signed-document-file';
import { Site } from './site';
import { SiteFile } from './site-file';
import { SiteUser } from './site-user';
import { SiteVendor } from './site-vendor';
import { SiteVendorFile } from './site-vendor-file';
import { SubNationalDivision } from './sub-national-division';
import { TinCheckReport } from './tin-check-report';
import { TradeCategory } from './trade-category';
import { TradeLicense, TradeLicense as TradeLicenses } from './trade-license';
import { TradeSpecialtyCategory } from './trade-specialty-category';
import {
  TradeSpecificCompliance,
  TradeSpecificCompliance as TradeSpecificCompliances
} from './trade-specific-compliance';
import { Transaction as RecentTransaction, Transaction } from './transaction';
import { User } from './user';
import { UserAccountRole } from './user-account-role';
import { Vendor } from './vendor';
import { VendorRanking } from './vendor-ranking';
import { VendorTrade } from './vendor-trade';
import { VendorTradeState } from './vendor-trade-state';
import { ViveProgress } from './vive-progress';
import { ZendeskGroup } from './zendesk-group';
import { ZendeskTicket } from './zendesk-ticket';
import { ZendeskTicketAttachment } from './zendesk-ticket-attachment';
import { ZendeskTicketComment } from './zendesk-ticket-comment';
import { ZendeskTicketField } from './zendesk-ticket-field';
import { ZendeskTicketForm } from './zendesk-ticket-form';
import { ZendeskUser } from './zendesk-user';

export {
  Address,
  ApConfig,
  ApVendor,
  ApVendorMeta,
  AssignedContractSite,
  BidContact,
  BillingContact,
  // Singularized class names
  BusinessVerificationApiError,
  BusinessVerificationApiErrorCode,
  CanadianWorkersCompensation,
  ClientRegisteredVendor,
  ClientRegisteredVendorFee,
  ClientRegisteredVendorInvoice,
  ClientRegisteredVendorInvoiceFee,
  Company,
  CompanyComplianceType,
  CompanyFee,
  CompanyOffice,
  CompanyOperationState,
  CompanyPackagePricing,
  CompanyRanking,
  CompanyServiceRanking,
  CompanyVendor,
  CompanyVendorFile,
  CompanyVendorOffice,
  CompanyVendorPayment,
  CompanyVendorStatusChange,
  ComplianceContact,
  ComplianceSetting,
  Contact,
  Contract,
  ContractSite,
  Email,
  ESignProvider,
  ESignTemplate,
  ExemptVendor,
  ExemptVendorType,
  File,
  FileContent,
  FrequencyPeriod,
  InsuranceCertificate,
  InsuranceDocument,
  InsurancePolicy,
  InsurancePolicySite,
  Invoice,
  IRSReport,
  LexNexReport,
  License,
  Licenses,
  MailingAddress,
  Note,
  Owner,
  OwnerFinding,
  PaymentCustomer,
  PaymentIdentifierSetup,
  PaymentProvider,
  PrimaryContact,
  PrimaryTrade,
  PrimaryTradeLicenseRequirement,
  PrimaryTradeLicenseRequirements,
  Proposal,
  ProposalFile,
  ProposalRequest,
  ProposalRequestFile,
  ProposalRequestVendor,
  RecentPaidCompanyVendorPayment,
  RecentPendingOrPaidCompanyVendorPayment,
  RecentTransaction,
  RemitToAddress,
  RequestJob,
  SignedDocument,
  SignedDocumentFile,
  Site,
  SiteContact,
  SiteFile,
  SiteUser,
  SiteVendor,
  SiteVendorFile,
  // Below are aliases of the same model
  StreetAddress,
  StripePaymentCustomer,
  SubNationalDivision,
  TinCheckReport,
  TradeCategory,
  TradeLicense,
  TradeLicenses,
  TradeSpecialtyCategory,
  TradeSpecificCompliance,
  // Pluralized class names
  TradeSpecificCompliances,
  Transaction,
  User,
  UserAccountRole,
  Vendor,
  VendorContact,
  VendorRanking,
  VendorTrade,
  VendorTradeState,
  ViveProgress,
  WCB,
  WSIB,
  ZendeskGroup,
  ZendeskTicket,
  ZendeskTicketAttachment,
  ZendeskTicketComment,
  ZendeskTicketField,
  ZendeskTicketForm,
  ZendeskUser
};
